import clsx from "clsx";
import { InputHTMLAttributes } from "react";
import * as styles from "./InputField.css";

export type InputProps = {
  error?: string | boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export function InputField({
  value = "",
  error,
  disabled,
  className,
  ...rest
}: InputProps) {
  const isFilled = typeof value === "string" && value.trim().length > 0;

  return (
    <>
      <input
        {...rest}
        value={value}
        disabled={disabled}
        className={clsx(
          styles.inputFieldBase,
          isFilled ? styles.inputFieldFilled : styles.inputFieldUnfilled,
          className,
          error && "inputError"
        )}
      />
      {!!error && (
        <div
          className={clsx(
            styles.helperText,
            error ? styles.visible : styles.hidden
          )}
        >
          {error}
        </div>
      )}
    </>
  );
}
